import createLogger from '~/lib/createLogger'

function createFilterFn(keysToFilter) {
  return function filterObject(obj) {
    if (Array.isArray(obj)) {
      return obj.map(filterObject)
    }

    if (obj && typeof obj === 'object') {
      return Object.fromEntries(
        Object.entries(obj).map(([key, value]) =>
          keysToFilter.includes(key)
            ? [key, '[FILTERED]']
            : [key, filterObject(value)]
        )
      )
    }

    return obj
  }
}

const logger = createLogger('SentryMiddleware', '#ea5937')

function createSentryMiddleware(sentry) {
  const filterObject = createFilterFn(['streaming', 'relatedLots'])

  function logAction(action) {
    if (sentry.getClient()?.getOptions()?.debug) {
      logger.debug('logAction', action)
    }

    const { type, ...data } = action

    sentry.addBreadcrumb({ category: 'redux', message: type, data })
  }

  return (_api) => (next) => (action) => {
    if (typeof action === 'object') {
      logAction(filterObject(action))
    }

    next(action)
  }
}

export default createSentryMiddleware
